<div class="panel-header">
	<div class="panel-actions">
		<button
			mat-raised-button
			color="primary"
			type="button"
			[matMenuTriggerFor]="createMenu"
		>
			<mat-icon>add</mat-icon>
			Create
		</button>
		<mat-menu #createMenu="matMenu" xPosition="before">
			<button mat-menu-item (click)="onCreate(PromiseToPayType.PTP)">
				<span>Promise to Pay</span>
			</button>
			<button mat-menu-item (click)="onCreate(PromiseToPayType.Arrangement)">
				<span>Arrangement</span>
			</button>
		</mat-menu>
	</div>
</div>

<div class="loading-row" *ngIf="isLoading">
	<mat-spinner diameter="24"></mat-spinner>
</div>

<div class="table-scroll">
	<table
		mat-table
		[dataSource]="rows"
		[trackBy]="trackById"
		class="flat-table"
	>
		<ng-container matColumnDef="promiseDate">
			<th mat-header-cell *matHeaderCellDef>Date</th>
			<td mat-cell *matCellDef="let row">{{ row.promiseDate }}</td>
		</ng-container>

		<ng-container matColumnDef="type">
			<th mat-header-cell *matHeaderCellDef>Type</th>
			<td mat-cell *matCellDef="let row">{{ typeLabel(row) }}</td>
		</ng-container>

		<ng-container matColumnDef="paymentMethod">
			<th mat-header-cell *matHeaderCellDef>Payment Method</th>
			<td mat-cell *matCellDef="let row">
				{{ paymentMethodLabel(row) }}
			</td>
		</ng-container>

		<ng-container matColumnDef="amount">
			<th mat-header-cell *matHeaderCellDef class="numeric">Amount</th>
			<td mat-cell *matCellDef="let row" class="numeric">
				{{ FormatUtil.formatCurrency(row.amount) }}
			</td>
		</ng-container>

		<ng-container matColumnDef="status">
			<th mat-header-cell *matHeaderCellDef>Status</th>
			<td mat-cell *matCellDef="let row">
				<span
					class="status-badge"
					[style.--status-color]="PromiseToPayStatus.getColor(row.status)"
				>
					{{ row.status }}
				</span>
			</td>
		</ng-container>

		<ng-container matColumnDef="owner">
			<th mat-header-cell *matHeaderCellDef>Owner</th>
			<td mat-cell *matCellDef="let row">{{ row.ownerName || '—' }}</td>
		</ng-container>

		<ng-container matColumnDef="actions">
			<th mat-header-cell *matHeaderCellDef></th>
			<td mat-cell *matCellDef="let row">
				<mat-spinner
					*ngIf="isBusy(row); else rowActions"
					diameter="20"
				></mat-spinner>

				<ng-template #rowActions>
					<button
						mat-icon-button
						type="button"
						aria-label="More actions"
						[matMenuTriggerFor]="menu"
					>
						<mat-icon>more_vert</mat-icon>
					</button>

					<mat-menu #menu="matMenu">
						<button mat-menu-item (click)="onViewHistory(row)">
							<mat-icon>history</mat-icon>
							<span>History</span>
						</button>
						<button
							mat-menu-item
							*ngIf="canEdit(row)"
							(click)="onEdit(row)"
						>
							<mat-icon>edit</mat-icon>
							<span>Edit</span>
						</button>
						<button
							mat-menu-item
							*ngIf="canCancel(row)"
							(click)="onCancel(row)"
						>
							<mat-icon>block</mat-icon>
							<span>Cancel</span>
						</button>
					</mat-menu>
				</ng-template>
			</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
	</table>
</div>

<div class="empty-state" *ngIf="!isLoading && rows.length === 0">
	<mat-icon>inbox</mat-icon>
	<p>Nothing recorded on this loan yet.</p>
</div>

